import React, { useState, useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { HowItWorks } from './components/HowItWorks';
import { Features } from './components/Features';
import { PlatformGrid } from './components/PlatformGrid';
import { Architecture } from './components/Architecture';
import { Integrations } from './components/Integrations';
import { WhoItsFor } from './components/WhoItsFor';
import { FAQ } from './components/FAQ';
import { LogoMarquee } from './components/LogoMarquee';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PilotPage } from './components/PilotPage';
import { PrivacyPolicy } from './components/PrivacyPolicy';
import { TermsOfUse } from './components/TermsOfUse';

const App: React.FC = () => {
  const [currentView, setCurrentView] = useState<'home' | 'pilot' | 'privacy' | 'terms'>('home');

  // Smooth scroll to top when view changes
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentView]);

  const handleNavigate = (view: 'home' | 'pilot' | 'privacy' | 'terms') => {
    setCurrentView(view);
  };

  return (
    <div className="min-h-screen bg-brandBg scroll-smooth">
      <Navbar onNavigate={handleNavigate as any} currentView={currentView as any} />
      
      <main>
        {currentView === 'home' && (
          <>
            <Hero onNavigate={handleNavigate as any} />
            <LogoMarquee />
            <ProblemSection />
            <HowItWorks />
            
            {/* PLATFORM OVERVIEW */}
            <Architecture />
            
            {/* COMPATIBILITY, CONNECTIVITY & SECURITY */}
            <Integrations />
            
            <PlatformGrid />
            
            {/* DIFFERENTIATOR */}
            <Features /> 
            
            {/* SOLUTIONS */}
            <WhoItsFor />
            
            {/* CONCLUDING SECTIONS */}
            <FinalCTA onNavigate={handleNavigate as any} />
            <FAQ onNavigate={handleNavigate as any} />
          </>
        )}
        
        {currentView === 'pilot' && (
          <PilotPage onNavigate={handleNavigate as any} />
        )}

        {currentView === 'privacy' && (
          <PrivacyPolicy onNavigate={handleNavigate as any} />
        )}

        {currentView === 'terms' && (
          <TermsOfUse onNavigate={handleNavigate} />
        )}
      </main>
      
      <Footer onNavigate={handleNavigate} />
    </div>
  );
};

export default App;